import { convertLength } from '@turf/helpers';
import { isNil } from 'lodash-es';

import {
  AddressOption,
  AddressOptionForNewSite,
} from '~components/Order/SiteSelection/types';
import { AddressItem } from '~hooks/useAddress/models/AddressItem';

export const formatAddressOptionForSiteForm = ({
  addressOption,
}: {
  addressOption: AddressOption;
}): AddressOptionForNewSite => {
  const { lat, lng } = addressOption;

  const mappedSite = {
    address: addressOption.address as AddressItem,
    name: '',
    lat: Number(lat),
    lng: Number(lng),
    latLon: `${lat}, ${lng}`,
    placeId: addressOption.placeId,
  };

  return mappedSite;
};

export const getFormattedLatLng = (lat: string | undefined, lng: string | undefined) => {
  const numLat = lat ? Number.parseFloat(lat).toFixed(6) : '';
  const numLng = lng ? Number.parseFloat(lng).toFixed(6) : '';
  return { lat: numLat, lng: numLng };
};

export const radiusInProperUnits = (isFeet: boolean, radius: number | null) => {
  if (isNil(radius)) {
    return null;
  }
  return isFeet ? Math.round(Number(convertLength(radius, 'meters', 'feet'))) : radius;
};

export const appendPinDropToName = (name: string): string => {
  const pinDropText = 'Pin Drop';
  if (!name || name.trim() === '') {
    return pinDropText;
  }
  if (!name.includes(pinDropText)) {
    return `${pinDropText} - ${name}`;
  }
  return name;
};
